<template>
  <!-- <div :class="{'has-logo':showLogo}"> -->
	<div>
		<el-scrollbar wrap-class="scrollbar-wrapper">
            <div v-if="loginKey" class="text" style="height:56px;line-height: 56px;display: flex;flex-direction: column;align-items: center;justify-content: center;">
                <el-button type="text" @click="goto_eb">进入儿保平台</el-button>
            </div>
			<el-menu
				:default-active="activeMenu"
				:collapse="isCollapse"
				:background-color="variables.menuBg"
				:text-color="variables.menuText"
				:unique-opened="false"
				:active-text-color="variables.menuActiveText"
				:collapse-transition="false"
				mode="vertical"
			>
				<sidebar-item v-for="route in permission_routes" :key="route.path" :item="route" :base-path="route.path" />
			</el-menu>
			<!-- <div style="text-align: center;">
				<el-button type="success" @click="fenxiang">分享本机构</el-button>
			</div> -->
			<div style="display: flex; flex-direction: column; align-items: center; margin-bottom: 10px; margin-top: 12%;" class='imgs'>
				<!-- <span class="text" v-if="info.admin_user_name">{{ info.admin_user_name }}</span> -->
				<span class="text" v-if="info.admin_user_name">客服热线</span>
				<span class="text" v-if="info.admin_phone" style="padding-top:6px">{{ info.admin_phone }}</span>
				<span class="text" v-if="info.admin_phone" style="padding-top:6px">031188806690</span>
				<span class="text" style="padding-top:6px">在线客服↓</span>
				<!-- <img :src="logo1" class="sidebar-logo1"> -->
				<img :src="img1" class="sidebar-logo1">
			</div>
		</el-scrollbar>
		<!-- <logo :collapse="isCollapse" /> -->
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import Logo from "./Logo";
import SidebarItem from "./SidebarItem";
import variables from "@/styles/variables.scss";
import request from "../../../utils/request";
export default {
  	components: { SidebarItem, Logo },
	computed: {
		...mapGetters(["permission_routes", "sidebar", "show_logo"]),
		// logo1() {
		// 	return require("../../../assets/logow.png");
		// },
		activeMenu() {
			const route = this.$route;
			const { meta, path } = route;
			// if set path, the sidebar will highlight the path you set
			if (meta.activeMenu) {
				return meta.activeMenu;
			}
			return path;
		},
		// showLogo() {
		//   return this.$store.state.settings.sidebarLogo
		// },
		variables() {
			return variables;
		},
		isCollapse() {
			return !this.sidebar.opened;
		},
	},
	data() {
		return {
			img1:"https://epochwlkj.com/static/images/logow.png",
			info: {},
			openUrl:false,
            admin_token:'',
            loginKey:''
		};
	},
	mounted() {
		this.getinfo();
		// this.logo1();
	},
	methods: {
        goto_eb(){
            console.log(this.admin_token)
            console.log(this.loginKey)
            window.open('http://jryl.epochwlkj.com/#/threeLogin?token='+this.admin_token+'&loginKey='+this.loginKey);
        },
		getinfo() {
			request({
				url: "admin/AdminUser/info",
				method: "get",
				params: {},
			})
			.then((res) => {
				this.info = res.data.institution;
				this.admin_token = res.data.admin_token;
				this.loginKey = res.data.loginKey;
			})
			.catch((err) => {});
		},
		fenxiang() {
			const urlObject = new URL(window.location.href);
			let url = `${urlObject.protocol}//${urlObject.hostname}${urlObject.port ? `:${urlObject.port}` : ''}`;
			let a = this.info.id*1
			let encrypted = this.simpleEncrypt(a.toString(16));
			url = url+'/backend/#/application?id='+ encrypted
			// 检查API是否可用
			if (navigator.clipboard && navigator.clipboard.writeText) {
				try {
					navigator.clipboard.writeText(url);
					alert('本机构的分享链接已复制到剪贴板');
				} catch (err) {
					console.error('无法复制到剪贴板:', err);
				}
			} else {
				this.openUrl = true;
				// 老旧浏览器可能不支持此API，弹框展示
				this.$alert(url, '本机构的分享链接', {
					confirmButtonText: '确定',
				});
			}
		},
		// 自定义加密方法
		simpleEncrypt(id) {
			var a = ','+id
			let paddingLength = 10 - a.length;
			let str = this.generateRandomString(paddingLength)
			var encryptPass = window.btoa(str+a);
			return encryptPass
		},
		generateRandomString(length) {  
			let result = '';  
			const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';  
			const charactersLength = characters.length;  
			for (let i = 0; i < length; i++) {  
				result += characters.charAt(Math.floor(Math.random() * charactersLength));  
			}  
			return result;  
		},
		logo1() {
			// var img1 = "郑.png";
			request({
				url: "admin/AdminUser/keFu",
				method: "get",
				params: {type:1},
			})
			.then((res) => {
				if(res.code==200){
					this.img1 = "https://epochwlkj.com/static/images/"+res.data;
				}else{
					this.img1 = "https://epochwlkj.com/static/images/logow.png";
				}
				
			})
			.catch((err) => {
				this.img1 = "https://epochwlkj.com/static/images/logow.png";
			});

		},
	},
};
</script>
<style>
	.text {
		font-size: 14px;
		padding: 0 7px 0 8px;
		color: #BFCBD9;
	}
	.el-menu {
		background-color: #12644e !important;
	}
	.el-menu-item,
	.el-submenu__title {
		background-color: #12644e !important;
	}
	#app .sidebar-container {
		background-color: #12644e !important;
	}
    .text .el-button--text{
        color: #BFCBD9;
    }
    .text .el-button--text:hover{
        color: #BFCBD9;
    }
	
	.imgs{
		overflow:hidden;
	}
	.sidebar-logo1 {
		width: auto;
		height: 65px;
		/* vertical-align: middle; */
		margin-right: 6px;
		margin-left: 6px;
		display: block;
		margin: 20px auto;
		transition:transition 0.3s ease;
	}
	.imgs:hover img{
		transform:scale(1.5);
	}
</style>
